import {regexes} from "../helpers/regexes";

// Example POST method implementation:
export const postToDTonomyAPI = async function postToDTonomyAPI(endpoint = '', data = {}) {
    const apiUrl = "https://plugin.dtonomy.com/api/"
    const proxyUrl = 'https://outlook.dtonomy.com:8080/';
    const url = apiUrl + endpoint;
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'POST', 
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    console.log(response);
    return response.json(); // parses JSON response into native JavaScript objects
  }

  // Example POST method implementation:
export const getFromDTonomyAPI = async function getFromDTonomyAPI(endpoint = '') {
    const apiUrl = "https://plugin.dtonomy.com/api/"
    const proxyUrl = 'https://outlook.dtonomy.com:8080/';
    const url = apiUrl + endpoint;
    // Default options are marked with *
    const response = await fetch(url, {
      method: 'GET', 
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });
    console.log(response);
    return response;
  }
  
export const sleep = function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}  

export const extractIP = function extractIP(text){
  const ip = text.match(regexes.ip4Addr) || text.match(regexes.ip6Addr);
  if (ip === null) {
    return '';
  }
  else{
    return ip[0].trim();
  }
}

export function asyncResolve(asyncResult, resolve) {
  if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
    // Return string of html body
    resolve(asyncResult.value.trim());
  }
  else {
    if (asyncResult.error.code == 9020) {
      // GenericResponseError returned when there is no context.
      // Treat as no context.
      resolve("");
    }
    else {
      // Handle the error.
      resolve("");
    }
  }
}
